/**
 * Centralised package version.
 * Works in both tsc multi-file output (dist/version.js) and
 * esbuild single-file bundle (dist/cli.js) because both live one
 * level below the project root that contains package.json.
 */
import { readFileSync } from 'fs';
import { fileURLToPath } from 'url';
import { dirname, join } from 'path';

let _version = 'unknown';
try {
  const dir = dirname(fileURLToPath(import.meta.url));
  const pkg = JSON.parse(readFileSync(join(dir, '..', 'package.json'), 'utf-8'));
  if (pkg.version) _version = pkg.version;
} catch { /* fallback */ }

export const CLI_VERSION: string = _version;
